import { render, staticRenderFns } from "./import-ledgers-side-action.vue?vue&type=template&id=20df9374"
import script from "./import-ledgers-side-action.ts?vue&type=script&lang=js&external"
export * from "./import-ledgers-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports